import React from "react";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import styled from "styled-components";

import './App.css';
import { FONT_COLOR, BACKGROUND_COLOR, ACCENT_YELLOW_COLOR } from './const'
import HomepageContainer from './containers/homepageContainer';

const StyledNavBar = styled(Navbar)`
  background-color: ${BACKGROUND_COLOR};
  display: flex;
  flex-direction: row;
  width: 100vw;
  align-items: space-between;
  font-size: 3em;
  height: 64px;
  color: purple;
`

const StyledContactContent = styled(Nav)`
  display: flex;
  ${'' /* align-items: center; */}
  height: 100%;
  width: 100%;
  font-size: 0.8em;
  justify-content: flex-end;
  background-color: ${BACKGROUND_COLOR};
  padding-left: 10px;
`

const StyledHome = styled.a `
  color: ${ACCENT_YELLOW_COLOR};
  width: 30vw;
  &:hover {
    color: ${FONT_COLOR};
  }
`

const StyledToggle = styled(Navbar.Toggle)`
  background-color: ${FONT_COLOR};
`

const StyledLink = styled(Nav.Link)`
  color: ${ACCENT_YELLOW_COLOR};
  padding-left: 20px;

  &:hover {
    color: ${FONT_COLOR};
  }
`

function App() {
  return (
    <React.Fragment>
      <StyledNavBar collapseOnSelect expand="md" sticky="top">
        <StyledToggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <StyledHome href="#home">JMa</StyledHome>
          <StyledContactContent id="navbar-wrapper" className="mr-auto">
            {/* <StyledLink href="#likes">Likes</StyledLink> */}
            {/* <StyledLink href="#skills">Skills</StyledLink> */}
            <StyledLink href="#resume">Resume</StyledLink>
            <StyledLink href="https://github.com/jacklynhma"><i className="fab fa-github"></i></StyledLink>
            <StyledLink href="https://www.linkedin.com/in/jacklyn-ma/"><i className="fab fa-linkedin-in"></i></StyledLink>
            <StyledLink href="/contactMe"><i className="far fa-envelope"/></StyledLink>
          </StyledContactContent>
        </Navbar.Collapse>
      </StyledNavBar>
      <HomepageContainer />
    </React.Fragment>
  );
}

export default App;